import { Box } from '@mui/material';
import { forwardRef, ReactNode } from 'react';
import { ChartTooltipMulti } from './ChartTooltipMulti';
import { ChartTooltipSingle } from './ChartTooltipSingle';
import { TooltipData } from './types';

interface TooltipProps {
  data: TooltipData | null;
  visible: boolean;
  renderSingleTooltip?: (data: TooltipData) => ReactNode;
}

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  ({ data, visible, renderSingleTooltip }, ref) => {
    if (!visible || !data) {
      return null;
    }

    const isSingle = data.mode === 'single' && data.series.length === 1;
    const singleContent = isSingle
      ? (renderSingleTooltip?.(data) ?? <ChartTooltipSingle data={data} />)
      : null;

    return (
      <Box
        ref={ref}
        sx={{
          position: 'absolute',
          left: data.x,
          top: data.y,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          color: 'white',
          padding: '8px 12px',
          borderRadius: '4px',
          fontSize: '12px',
          fontFamily: isSingle && renderSingleTooltip ? 'inherit' : 'monospace',
          pointerEvents: 'none',
          zIndex: 1000,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          minWidth: isSingle ? '100px' : '120px',
          maxWidth: isSingle && renderSingleTooltip ? '240px' : isSingle ? '160px' : '200px',
        }}
      >
        {isSingle ? singleContent : <ChartTooltipMulti data={data} />}
      </Box>
    );
  },
);

Tooltip.displayName = 'Tooltip';

export default Tooltip;
